import Vue from 'vue';

export default {
    name: 'auth-required',
    async handle(to, from, next) {
        await Vue.state.player.ensure();
        await Vue.state.client.ensure();

        let client = Vue.state.client.get();

        var authenticationRequired = client.view.auth.authenticationRequired;
        var authenticationRoute = client.view.authenticationRoute || 'login';
        if (
            !authenticationRequired
            ||
            Vue.state.player.isLoggedIn()
            ||
            to.matched.some(record => record.meta.requiresAuth === false)
            ||
            to.name === authenticationRoute
        ) {
            return false;
        }

        next({ name: authenticationRoute });
        return true;
    }
};



// WEBPACK FOOTER //
// ./_common/routehandlers/auth-required.routehandler.js